import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#D9DCDF",
      "fill-rule": "evenodd",
      d: "M14.91 2.084a.837.837 0 0 1 .626-.043.813.813 0 0 1 .473.4l2.404 4.696c1.478.111 2.405.395 3.003 1.117.983 1.189.591 2.976-.193 6.553l-.468 2.134c-.532 2.424-.798 3.636-1.699 4.348-.9.711-2.17.711-4.708.711H9.652c-2.538 0-3.807 0-4.707-.712-.902-.711-1.168-1.923-1.7-4.347l-.468-2.134C1.993 11.23 1.6 9.443 2.584 8.254c.599-.723 1.526-1.006 3.003-1.117l2.404-4.695a.814.814 0 0 1 .474-.397.837.837 0 0 1 .622.044c.193.094.34.26.41.46.07.2.055.418-.04.607L7.453 7.072c.527-.005 1.103-.005 1.732-.005h5.63c.63 0 1.205 0 1.733.005l-2.004-3.914a.783.783 0 0 1-.044-.611.804.804 0 0 1 .41-.462ZM6.814 12.4a.79.79 0 0 1 .24-.566.829.829 0 0 1 .579-.234h8.737c.217 0 .425.084.579.234a.79.79 0 0 1 0 1.131.83.83 0 0 1-.58.235H7.633a.83.83 0 0 1-.58-.235.79.79 0 0 1-.24-.565Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }